export const createFormikHelpers = (formik) => {
  const fieldMeta = (name) => formik.getFieldMeta(name)

  const fieldValue = (name, fallback = null) =>
    fieldMeta(name).value ?? fallback

  const fieldError = (name) => {
    const field = fieldMeta(name)
    return field.touched ? field.error : undefined
  }

  const fieldTouched = (name) => fieldMeta(name).touched

  const setFieldValue = (name, nextValue) =>
    formik.setFieldValue(name, nextValue)

  const setTouched = (touched, shouldValidate = false) =>
    formik.setTouched(touched, shouldValidate)

  return {
    ...formik,
    fieldMeta,
    fieldValue,
    fieldError,
    fieldTouched,
    setFieldValue,
    setTouched,
  }
}
